import { Component, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { VtmnPlayIconButtonSizeEnum } from '~/component/buttons/vtmn-play-icon-button/enum/vtmn-play-icon-button-size.enum';
import { VtmnPlayIconButtonVariantEnum } from '~/component/buttons/vtmn-play-icon-button/enum/vtmn-play-icon-button-variant.enum';
import { CtaButtonTypeEnum } from '~/component/call-to-action/enums/button-type.enum';

import { KeyboardEnum } from '~/component/enums/keyboard.enum';
import { FormControlChildAbstract } from '~/component/form/abstracts/control-child.abstract';
import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';

@Component({
  selector: 'app-input-counter',
  templateUrl: './input-counter.component.html',
  styleUrls: ['./input-counter.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: FormInputCounterComponent,
      multi: true,
    },
  ],
})
export class FormInputCounterComponent
  extends FormControlChildAbstract<number>
  implements OnInit
{
  @Input() public help?: string;
  @Input() public label?: string;
  @Input() public max = 100;
  @Input() public min = 0;
  @Input() public name?: string;

  public readonly ctaButtonType = CtaButtonTypeEnum;
  public readonly vtmnPlayIconButtonSize = VtmnPlayIconButtonSizeEnum;
  public readonly vtmnPlayIconButtonVariant = VtmnPlayIconButtonVariantEnum;

  public iconType = VtmnPlayIconTypeEnum;

  public ngOnInit(): void {
    if (!this.id) {
      this.id = this.name;
    }
  }

  public get canDecrement(): boolean {
    return !this.disabled && this.value > this.min;
  }

  public get canIncrement(): boolean {
    return !this.disabled && this.value < this.max;
  }

  public decrement(): void {
    if (!this.canDecrement) {
      return;
    }

    this.value--;
  }

  public increment(): void {
    if (!this.canIncrement) {
      return;
    }

    this.value++;
  }

  public onKeydown(event: KeyboardEvent): void {
    if (event.code === KeyboardEnum.ArrowUp) {
      event.preventDefault();
      this.increment();
    }

    if (event.code === KeyboardEnum.ArrowDown) {
      event.preventDefault();
      this.decrement();
    }

    if (event.code === KeyboardEnum.Home) {
      event.preventDefault();
      this.value = this.min;
    }

    if (event.code === KeyboardEnum.End) {
      event.preventDefault();
      this.decrement();
      this.value = this.max;
    }
  }
}
